module.exports = __webpack_public_path__ + "assets/language-squares/ru@2x-b5c7a031f2a72242b9c68696c0d883c5.jpg";